module.exports = __webpack_public_path__ + "static/img/78039A_R_2_20171015_LC.c2c6515.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/78039A_R_2_20171015_LC.png
// module id = P+IS
// module chunks = 0